<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <div class="row align-items-center justify-content-between">
          <div class="col-lg-10 col-12 row pr-0">
            <div class="col-lg-4 col-12 pr-0">
                <label class="p-col-fixed txt-left p-0 m-0">Thời gian</label>
                <div class="p-col p-0 pt-1">
                  <Calendar v-model="dateReport" placeholder="DD/MM/YYYY - DD/MM/YYYY" class="w-100" appendTo="body" :showButtonBar="true" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true"/>
                </div>
            </div>
            
            <div class="col-lg-4 col-12 pr-0">
                <label class="p-col-fixed txt-left p-0 m-0">Trang trại</label>
                <div class="p-col p-0 pt-1">
                  <Dropdown class="col-12" v-model="farm" :options="farmOptions" optionLabel="name" placeholder="Tất cả" :showClear="true"/>
                </div>
            </div>
          </div>

          <!-- <div class="col-lg-2">
            <Button class="btn-main" label="Xuất danh sách xuất cua" @click="exportExcel()"/>
          </div> -->
        </div>
        <BlockTotal :data.sync="total_report" :loading.sync="totalLoading" :decimal="3"/>
        <!--{{listData}}-->
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          @getFilters="getFilters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          :whereKeyList="whereKeyList"
          v-on:action-click="onActionClicked"
        ></BaseDatatable>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
import gql from "graphql-tag";
import BlockTotal from '@/components/blockTotal'
import ApiRepository from "@/core/ApiRepository";
// import Popup from './popup'
export default {
  components: {
    BaseDatatable,
    BlockTotal
    // Popup
  },
  data() {
    return {
      total_report: [
        {
          label: 'Tổng TL xuất (kg)',
          value: 0,
        },
        {
          label: 'Tổng SL con',
          value: 0
        }
      ],
      totalLoading: false,
      filters: {},
      filterOptions: {},
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      whereKeyList:{
        where_key: {
          deleted_at: {_is_null: true}
        }
      },
      page_transaction:null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      showLockDialog : false,
      showPointDialog: false,
      point : 10,
      fullname : "HÙNG dEMO",
      phone : "0987654321",
      list_option : [
        {value : "ADD" , name : "Cộng"},
        {value : "SUB" , name : "Trừ"}
      ],
      selType : {value : "ADD" , name : "Cộng"},
      point_change : null,
      uid_change : "",
      farmOptions: [],
      dateReport: null,
      farm: null,
      options: []
    }
  },
  // mounted () {
  //   this.initParams();
  // },
  async created() {
    await this.initParams();
    await this.getListFarm();
    this.$set(this, 'dateReport', [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_USER);
    // // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    // //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // // }
    // console.log("arr_role:" ,arr_role)
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    "dateReport" : {
      async handler()
      {
        // this.loading = true;
        if (!this.$commonFuction.isEmpty(this.dateReport) && !this.$commonFuction.isEmpty(this.dateReport[0]) && !this.$commonFuction.isEmpty(this.dateReport[1])) {
          const from = this.dateReport[0];
          const to = new Date(this.dateReport[1]);

          // Make sure 'to' includes the full day
          to.setHours(23, 59, 59, 999);

          this.$set(this.filters, 'created_at_filter', {
            value: { from, to },
            type_input: 'DateRange'
          });
          if (!this.totalLoading) {
            this.getData();
          }
        } else {
          this.$delete(this.filters, 'created_at_filter');
          if (!this.totalLoading) {
            this.getData();
          }
        }
        return;
      }
    },
    "farm"() {
        if (this.farm?.id) {
            this.$set(this.filters, 'farm_id', {value: this.farm?.id, type_input: 'select'});
            if (!this.totalLoading) {
              this.getData();
            }
        } else {
            this.$delete(this.filters, 'farm_id');
            if (!this.totalLoading) {
              this.getData();
            }
        }
        return;
    }
  },
  methods: {
    getFilters(filters) {
        // this.filters = Object.assign({...this.filters, ...filters});
        // console.log("filters.filters", filters.filters);
        this.filters = Object.assign({...this.filters, ...filters?.filters});
        this.first = filters.first;
        this.rows = filters.rows;
        return;
    },
    async getData() {
      // this.lazyParams.filters = this.filtersCustom;
      this.totalLoading = true;
      var headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
      }
      
      var filter = {};
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          filter[key] = value.value;
        }
      }
      ApiRepository.post("_api/import_export/export", {filters: filter, first: this.first, rows: this.rows}, {headers}).then((res) => {
        const {data} = res;
        this.total_report = data?.data?.report || [
          {
            label: 'Tổng TL xuất (kg)',
            value: 0,
          },
          {
            label: 'Tổng SL con',
            value: 0
          }
        ];
        this.totalLoading = false;
      }).catch(async error => {
          console.log('error', error);
          this.$toast.add({
              severity: 'error',
              summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
              life: 3000
          });
          this.totalLoading = false;
      });
    },
    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where = {
          active: {_eq: true}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: "desc" },
        },
      });
      var listData = resData.data["farm"];
      this.farmOptions = listData;
    },
    exportExcel() {
      // console.log("exported");
    },
    initParams() {
      this.$store.commit('setLoading', true);
      // this.$set(this, 'dateReport', [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      this.callbackOptions();
    },
    async callbackOptions() {
      // console.log("tettststststst:ssssss")
      var fields = this.dataModel.getDisplayFields();
      // console.log("tettststststst:",fields)
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        // console.log("elementelementelementelement", element);
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models?.key?.key);
          attributes.push(element.models.display_key);
          var where_ = {}
          if (element.where_option){
            where_ = element.where_option
          }
          var {data} = await this.$apollo.query({
            query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_}
          })
          if (data) {
            var result = data[Object.keys(data)];
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
              }
            }
          }
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }

    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection' || field?.options) {
        //result = field.options;
        if (field.options ) {
           result = field.options;
        } else if(field.models && this.options[name]) { 
          result = this.options[name];
          // console.log("this.options[name]", this.options[name]);
        }
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("field.type:",field.type);
      // console.log("resultresultresultresult11:",result);
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // if (this.role.add) {
        // actions.header = {name: 'add', icon: 'plus', path: `list-export/add`};
      // }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        // if (that.role.edit) {
        //   buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-unit/edit/`};
        // }
        // if(rowData.active == true ){
        //   buttons.lock = { name: 'lock', icon: 'eye'};
        // }
        // else if(rowData.active == false){
        //   buttons.unlock = { name: 'unlock', icon: 'eye-slash'};
        // }

        // if (that.role.delete) {
        //   buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        // }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },

    async lockData() {
      this.showLockDialog = false
      var uid = this.LockId;
      var users_object = {
            'active': false
          };

      var queryUpdate = `
        mutation update_users_multil($users_object: users_set_input) {
          update_users(where: { id: {_eq: "${uid}"}}, _set: $users_object) {
            affected_rows
            returning {
              id
            }
          }
          delete_jwt_token(where: { uid: { _eq: "${uid}" }}) {
            returning {
              id
            }
          }

        }
      `;
      let variables = {
        users_object: users_object,
      };

      this.$apollo.mutate({
        mutation: gql(queryUpdate),
        variables: variables
      }).then(async() => {  
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Ẩn thành công', life: 3000 })
        this.componentKey++;
      })
    },


    async unlockData() {
      this.showUnLockDialog = false
      var uid = this.UnLockId;
      var users_object = {
        'active': true,
          };

      var queryUpdate = `
        mutation update_users_multil($users_object: users_set_input) {
          update_users(where: { id: {_eq: "${uid}"}}, _set: $users_object) {
            affected_rows
            returning {
              id
            }
          }
          delete_jwt_token(where: { uid: { _eq: "${uid}" }}) {
            returning {
              id
            }
          }

        }
      `;
      let variables = {
        users_object: users_object,
      };

      this.$apollo.mutate({
        mutation: gql(queryUpdate),
        variables: variables
      }).then(async() => {  
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Mở ẩn thành công', life: 3000 })
        this.componentKey++;
      })
    },

    




    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            // console.log("payload.lazyParams:111"+pageTransaction,payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
        case 'point':
          this.showPointDialog = true
          this.point = data.data.point ? data.data.point : 0
          this.fullname = data.data.fullname ? data.data.fullname : ''
          this.phone = data.data.phone ? data.data.phone : ''
          this.uid_change = data.data.id
        break
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      // console.log("testttttttttt");
      this.$commonFuction.is_loading(true);
      var uid = this.deleteId;
      var that = this;
      //Xóa account cũ
      
      // id mới dc thêm vào
      var userUpdate = {
        deleted_at: new Date()
      };
      var accountUpdate = {
        deleted_at: new Date()
      }
      var queryUpdate = `
                mutation update_users_multil($users_object: users_set_input,$accounts_object: accounts_set_input,$group_user_object: group_user_set_input) {
                  update_users(where: { id: {_eq: "${uid}"}}, _set: $users_object) {
                    affected_rows
                    returning {
                      id
                    }
                  }
                  update_accounts(where: { uid: {_eq: "${uid}"}}, _set: $accounts_object) {
                    affected_rows
                    returning {
                      id
                    }
                  }
                  delete_jwt_token(where: { uid: { _eq: "${uid}" }}) {
                    returning {
                      id
                    }
                  }
                }
          `;

      let variables = {
        users_object: userUpdate,
        accounts_object: accountUpdate,
      };
      that.$apollo.mutate({
        mutation: gql(queryUpdate),
        variables: variables
      }).then(async (res) => {
        console.log(res);
      }).then(() => {
        var router_back = {path: '/admin/list-users'};
        if (!that.$commonFuction.isEmpty(router_back)){
          // console.log("that.page_transaction:",that.page_transaction);
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
        that.$commonFuction.is_loading(false);
        that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        //that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
        window.location.reload()
      });
    },
    
  }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
#cus-table {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}
.td-class-right{
  text-align: right;
  width:50%;
  font-weight: 500;
}
.td-class-left{
  text-align: left;
  padding-left: 3px;
  width:50%;
}
</style>